// extracted by mini-css-extract-plugin
export var screen1__date = "screen1-module--screen1__date--87120";
export var screen1__doItem = "screen1-module--screen1__do-item--844bb";
export var screen1__doList = "screen1-module--screen1__do-list--46beb";
export var screen1__info = "screen1-module--screen1__info--76891";
export var screen1__innerContainer = "screen1-module--screen1__inner-container--b366c";
export var screen1__mainInfo = "screen1-module--screen1__main-info--528fd";
export var screen1__subtitle = "screen1-module--screen1__subtitle--6bf75";
export var screen1__title = "screen1-module--screen1__title--97ce9";